module.exports = __webpack_public_path__ + "img/error-dark.145f4548.svg";